import { combineReducers } from 'redux-immutable';
import { routerReducer } from 'react-router-redux';

const appReducer = combineReducers({
  router: routerReducer,
});

const rootReducer = (state, action) => {
  let newState = state;
  return appReducer(newState, action);
};

export default rootReducer;
